import { createState } from '~/src/hooks/useEoState'
import { Templates } from '~/src/types/Templates'

const key = 'stylesState'

export const STYLES_STATE = createState<Templates | null>({
  key,
  default: null
})
